import React from 'react';
import GrassIcon from '@mui/icons-material/Grass';

import { useI18n } from '../../../hooks/useI18n';
import { TranslationKeys } from '../../../i18n/locales/defaultResources';
import { BannerButton, BannerContainer } from './styles';
import { BannerProps } from './types';

const FieldNominationBanner: React.FC<BannerProps> = ({ onClick }) => {
  const { t } = useI18n();

  return (
    <BannerContainer>
      <BannerButton onClick={onClick}>
        {t(TranslationKeys.field_nomination_banner_text)}
        <GrassIcon sx={{ color: 'white', size: '64px', marginLeft: '5px' }} />
      </BannerButton>
    </BannerContainer>
  );
};

export default FieldNominationBanner;
